import React from "react";

const Members: React.FC = () => {
  return <>MEMBERS PAGE</>;
};

export default Members;
